export const NoPage = ({ width = 64 }: { width?: number }) => (
  <svg width={width} height={width} viewBox="0 0 64 64" fill="none">
    <path
      d="M46.1965 54.6171L47.2686 53.5463V19.3696L46.955 18.6129L38.6465 10.3141L37.888 10H17.0721L16 11.0708V53.5463L17.0721 54.6171H46.1965Z"
      fill="#B2ABAB"
    />
  </svg>
);
